import React from "react";

const SectionHeader = ({ 
  title, 
  subtitle, 
  actionLabel, 
  onActionClick, 
  Icon 
}) => {
  return (
    /* 
       Perubahan: flex-col untuk mode tumpuk, 
       lg:flex-row untuk kembali berjajar saat layar luas.
    */
    <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
      <div>
        <h2 className="text-xl font-black text-[#003366] dark:text-white tracking-tighter uppercase">
          {title}
        </h2>
        <p className="text-xs text-slate-400 font-bold uppercase tracking-widest mt-1">
          {subtitle}
        </p>
      </div>
      
      {actionLabel && (
        <button 
          onClick={onActionClick}
          /* 
             Perubahan: 
             - w-full: Agar tombol melebar penuh saat bertumpuk.
             - lg:w-auto: Agar tombol kembali ke ukuran aslinya di layar lebar.
          */
          className="flex items-center justify-center gap-2.5 px-6 py-3 bg-[#0F172A] text-white rounded-xl text-[10px] font-black uppercase tracking-[0.15em] shadow-lg shadow-slate-900/20 active:scale-95 border border-white/10 w-full lg:w-auto transition-all"
        >
          {Icon && (
            <Icon 
              size={14} 
              className="text-white"
            />
          )} 
          {actionLabel}
        </button>
      )}
    </div>
  );
};

export default SectionHeader;